import React from 'react'
import styled from 'styled-components/macro'

const tips = [
  {
    title: 'Så undviker du vanliga fel inför besiktningen',
    href: 'https://opus.se/nyheter/sa-undviker-du-vanliga-fel-infor-besiktningen/',
  },

  {
    title: 'Se upp för vilt på vägarna',
    href: 'https://opus.se/tjanster/kontrollbesiktning/sa-hanterar-och-forebygger-du-viltolyckor/',
  },

  {
    title: 'Har du koll på däcken?',
    href: 'https://opus.se/nyheter/har-du-koll-pa-dacken/',
  },

  {
    title: 'Bilexpertens vintertips för din bil',
    href: 'https://opus.se/nyheter/bilexpertens-vintertips-for-din-bil/',
  },

  {
    title: 'Så här tvättar du bilen rätt',
    href: 'https://opus.se/nyheter/tvatta-bilen-som-ett-proffs/',
  },

  { title: 'Opus tar ett miljöansvar', href: 'https://opus.se/miljoansvar' },

  {
    title: 'Att bila med barn i bilen',
    href: 'https://opus.se/nyheter/att-bila-med-barn-i-bilen/',
  },

  {
    title: 'Importera bil från utlandet',
    href: 'https://opus.se/nyheter/importera-bil-fran-utlandet/',
  },
  {
    title: 'Vattenfall och Opus i samarbete för minskade klimatavtryck',
    href: 'https://opus.se/nyheter/vattenfall-och-opus-i-samarbete-for-minskade-klimatavtryck/',
  },
]

const TipsList = styled.ul`
  padding: 0;
`
const TipsListItem = styled.li`
  list-style-type: none;
  position: relative;
  padding-left: 2rem;
  margin: 1rem 0;

  a {
    font-weight: bold;
  }

  &::before {
    content: '\u27a4';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    color: ${props => props.theme.colors.primary};
  }
`

export function TipsPartial() {
  return (
    <>
      <h3>Tips till dig!</h3>
      <p>Här har vi samlat bra tips och råd om ditt fordon från några av alla artiklar som finns på vår webb.</p>
      <TipsList>
        {tips.map((tip, idx) => (
          <TipsListItem key={idx}>
            <a href={tip.href} rel="noopener noreferrer" target="_blank">
              {tip.title}
            </a>
          </TipsListItem>
        ))}
      </TipsList>
    </>
  )
}
